/** @jsxRuntime classic */
/** @jsx h */
import {
  AutocompletePlugin,
  getAlgoliaResults,
} from '@algolia/autocomplete-js';
import { SearchResponse } from '@algolia/client-search';
import { h } from 'preact';

import { ALGOLIA_PRODUCTS_INDEX_NAME } from '../constants';
import { searchClient } from '../searchClient';
import { QuickAccessHit } from '../types';
import { cx, intersperse } from '../utils';

export const quickAccessPlugin: AutocompletePlugin<QuickAccessHit, {}> = {
  getSources({ query }) {
    if (query) {
      return [];
    }



    return [
      {
        sourceId: 'quickAccessPlugin',
        getItems({setContext}) {
          return getAlgoliaResults<QuickAccessHit>({
            searchClient,
            queries: [
              {
                indexName: 'wp_csc_banners',
                query,
                params: {
                  hitsPerPage: 4,
                },
              },
            ],
            transformResponse({ hits, results }) {
              console.log(hits);
              setContext({
                nbQuickAccess: (results[0] as SearchResponse<QuickAccessHit>).nbHits,
              });

              return hits;
            },
          });
        },
        templates: {
          header({ Fragment }) {
            return (
              <Fragment>
                <span className="aa-SourceHeaderTitle">Quick access</span>
                <div className="aa-SourceHeaderLine" />
              </Fragment>
            );
          },
          item({ item }) {
            return <QuickAccessItem hit={item} />;
          },
        },
      },
    ];
  },
};
type QuickAccessItemProps = {
  hit: QuickAccessHit;
};

function QuickAccessItem({ hit }: QuickAccessItemProps) {
  return (
    <div>
      <a
        href={hit.href}
        className={cx(
          'aa-ItemLink aa-QuickAccessItem',
          `aa-QuickAccessItem--${hit.template}`
        )}
      >
        <div className="aa-ItemContent">
          {hit.image && (
            <div className="aa-ItemPicture">
              <img src={hit.image} alt={hit.title} />
            </div>
          )}
        </div>
      </a>
      <a
        href={hit.href}
        className={cx(
          'aa-ItemLink aa-QuickAccessItem',
          `aa-QuickAccessItem--${hit.template}`
        )}
      >
      <div>
        <div className="quickAccessTitle">{hit.title}</div>
      </div>
      </a>
    </div>
  );
}
